"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.grayButtonStyles = exports.default = exports.GetIdMap = void 0;
var _ArrowBackIosNew = _interopRequireDefault(require("@mui/icons-material/ArrowBackIosNew"));
var _ArrowForwardIos = _interopRequireDefault(require("@mui/icons-material/ArrowForwardIos"));
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _string = require("../../utils/type-checks/string");
var _emblaCarouselReact = _interopRequireDefault(require("embla-carousel-react"));
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge");
const GetIdMap = testId => {
    return {
      carousel: (0, _string.isStringOfLength)(testId) ? `id_${testId}__carousel` : undefined,
      slide: (0, _string.isStringOfLength)(testId) ? `id_${testId}__carousel-slide` : undefined,
      progressDot: (0, _string.isStringOfLength)(testId) ? `id_${testId}__carousel-progress-dot` : undefined
    };
  },
  grayButtonStyles = exports.grayButtonStyles = {
    position: "absolute",
    backgroundColor: "gray",
    borderRadius: "50%",
    minWidth: 40,
    height: 40,
    display: {
      xs: "none",
      md: "flex"
    },
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "gray"
    },
    "& .MuiSvgIcon-root": {
      color: "white"
    },
    "&:active": {
      transform: "scale(0.95)"
    }
  };
exports.GetIdMap = GetIdMap;
const Carousel = props => {
  const {
    carouselSlides,
    customStyles = {},
    customEmblaOptions = {},
    testId
  } = props;
  const styles = merge({
    maxWidth: "40rem",
    flexGrow: 1,
    position: "relative",
    mx: "auto",
    ".backButton": {
      ...grayButtonStyles,
      left: "-15rem"
    },
    ".embla__viewport": {
      overflow: "hidden",
      width: "100%"
    },
    ".embla__container": {
      display: "flex",
      flexDirection: "row",
      width: "100%"
    },
    ".embla__slide": {
      position: "relative",
      flex: "0 0 100%"
    },
    ".header": {
      display: "flex",
      alignItems: "center",
      textAlign: "center",
      margin: "1rem 0 5rem",
      height: "10rem"
    },
    ".imageSlide": {
      maxHeight: {
        xs: "49.2rem",
        sm: "60rem"
      },
      display: "block",
      maxWidth: {
        xs: "24.1rem",
        sm: "29.5rem"
      },
      overflow: "hidden",
      width: "100%",
      mx: "auto"
    },
    ".nextButton": {
      ...grayButtonStyles,
      right: "-15rem"
    },
    ".progress-container": {
      background: "transparent",
      marginTop: "2rem",
      justifyContent: "center",
      display: "flex",
      gap: "2rem"
    },
    ".progress-dot": {
      width: "2rem",
      height: "2rem",
      borderRadius: "50%",
      cursor: "pointer",
      backgroundColor: "#BDBDBD",
      border: "none"
    },
    ".progress-dot-selected": {
      backgroundColor: "#0073B0"
    },
    ".slide-container": {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, customStyles);
  const idMap = GetIdMap(testId);
  const emblaOptions = merge({
    loop: true,
    //to go from last to first and vice versa
    dragFree: false // disabling momentum scrolling aka letting it spin like crazy
  }, customEmblaOptions);
  const [emblaRef, emblaApi] = (0, _emblaCarouselReact.default)(emblaOptions);
  const [selectedIndex, setSelectedIndex] = (0, _react.useState)(0); // to manage current slide

  /*  Callback function to update the selected index when the carousel changes
   wrapped in useCallback to not re-create the function unless emblaApi changes */
  const updateSelectedIndex = (0, _react.useCallback)(() => {
    // get newIndex from emblaApi object
    const newIndex = emblaApi.selectedScrollSnap();
    setSelectedIndex(newIndex);
  }, [emblaApi]);

  // Event listeners for carousel changes
  (0, _react.useEffect)(() => {
    if (!emblaApi) {
      return;
    }
    ;

    // listens for slide selection changes
    emblaApi.on("select", updateSelectedIndex);
    // listens for carousel re-initialization
    emblaApi.on("reInit", updateSelectedIndex);

    // cleanup on dismount
    return () => {
      emblaApi.off("select", updateSelectedIndex);
      // listens for carousel re-initialization
      emblaApi.off("reInit", updateSelectedIndex);
    };
  }, [emblaApi, updateSelectedIndex]);

  // Go to previous slide
  const handlePrev = () => {
    emblaApi.scrollPrev();
  };

  // Go to next slide
  const handleNext = () => {
    emblaApi.scrollNext();
  };
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles,
    "data-testid": idMap.carousel
  }, (0, _string.isStringOfLength)(carouselSlides?.[selectedIndex]?.headerFragmentId) && /*#__PURE__*/_react.default.createElement(_material.Paper, {
    square: true,
    elevation: 0,
    className: "header",
    id: `slide-${carouselSlides?.[selectedIndex]?.headerFragmentId}`,
    "data-testid": `paper-${carouselSlides?.[selectedIndex]?.headerFragmentId}`
  }, /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    id: carouselSlides[selectedIndex].headerFragmentId,
    "data-testid": `headerFragment__${carouselSlides[selectedIndex].headerFragmentId}`
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "slide-container"
  }, /*#__PURE__*/_react.default.createElement(_material.Button, {
    size: "small",
    "aria-label": "Go Back",
    className: "backButton",
    onClick: handlePrev
  }, /*#__PURE__*/_react.default.createElement(_ArrowBackIosNew.default, {
    alt: "Chevron image pointing to the left"
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    ref: emblaRef,
    className: "embla__viewport"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "embla__container"
  }, carouselSlides.map((image, index) => {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      tabIndex: -1,
      className: "embla__slide",
      "data-testid": (0, _string.isStringOfLength)(testId) ? `${idMap.slide}--${index}` : undefined,
      "aria-hidden": index !== selectedIndex ? true : undefined,
      key: index,
      "aria-label": `Slide ${index + 1}`,
      "aria-describedby": (0, _string.isStringOfLength)(carouselSlides?.[index]?.headerFragmentId) && selectedIndex === index ? `slide-${carouselSlides?.[index]?.headerFragmentId}` : undefined
    }, image.component);
  }))), /*#__PURE__*/_react.default.createElement(_material.Button, {
    size: "small",
    "aria-label": "Go Forward",
    onClick: handleNext,
    className: "nextButton"
  }, /*#__PURE__*/_react.default.createElement(_ArrowForwardIos.default, {
    alt: "Chevron image pointing to the right"
  }))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "progress-container"
  }, carouselSlides.map((_, index) => {
    const compiledClassnames = (0, _classnames.default)({
      "progress-dot": true,
      "progress-dot-selected": selectedIndex === index
    });
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      component: "button",
      type: "button",
      className: compiledClassnames,
      key: `dot_${index}`,
      "aria-label": `Navigates user to slide ${index + 1}`,
      "data-slide": index,
      "data-testid": (0, _string.isStringOfLength)(testId) ? `${idMap.progressDot}--${index}` : undefined,
      onClick: () => emblaApi.scrollTo(index)
    });
  })));
};

// Define propTypes;
Carousel.propTypes = {
  // Required carouselSlides array to make the carousel slides.
  carouselSlides: _propTypes.default.arrayOf(_propTypes.default.shape({
    // Required component prop inside of an carouselSlides object
    component: _propTypes.default.object.isRequired,
    // Optional headerFragmentId, linked to component
    headerFragmentId: _propTypes.default.string
  })).isRequired,
  /* Custom options to modify embla carousel */
  customEmblaOptions: _propTypes.default.object,
  // Custom styles to modify default carousel styles
  customStyles: _propTypes.default.object,
  // Optional testId string for the carousel component
  testId: _propTypes.default.string
};
var _default = exports.default = Carousel;